var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomChip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "custom-chip_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 17 17",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".custom-chip_svg__st0{fill:none;stroke:currentColor;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "custom-chip_svg__Icon_-_Bets",
    transform: "translate(-416.5 -317.306)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "custom-chip_svg__Ellipse_60",
    className: "custom-chip_svg__st0",
    cx: 425,
    cy: 325.8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "custom-chip_svg__Ellipse_61",
    className: "custom-chip_svg__st0",
    cx: 424.9,
    cy: 325.9,
    r: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_114",
    className: "custom-chip_svg__st0",
    d: "M423.5 318.6l.5 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_115",
    className: "custom-chip_svg__st0",
    d: "M425.8 321l.4-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_116",
    className: "custom-chip_svg__st0",
    d: "M417.9 323.5l2.3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_117",
    className: "custom-chip_svg__st0",
    d: "M421 322.7l-1.9-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_118",
    className: "custom-chip_svg__st0",
    d: "M419.2 330.7l1.9-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_119",
    className: "custom-chip_svg__st0",
    d: "M420.2 327.5l-2.3.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_120",
    className: "custom-chip_svg__st0",
    d: "M426.3 333.2l-.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_121",
    className: "custom-chip_svg__st0",
    d: "M424 330.8l-.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_122",
    className: "custom-chip_svg__st0",
    d: "M431.9 328.3l-2.3-.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_123",
    className: "custom-chip_svg__st0",
    d: "M428.8 329.1l1.9 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_124",
    className: "custom-chip_svg__st0",
    d: "M430.6 321.1l-1.9 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-chip_svg__Line_125",
    className: "custom-chip_svg__st0",
    d: "M429.6 324.3l2.3-.9"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgCustomChip as ReactComponent };